"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToIpv4 = exports.ipv4ToNumber = void 0;
const ipv4ToNumber = (ip) => {
    const octets = ip.split('.').map(Number);
    return ((octets[0] << 24) | (octets[1] << 16) | (octets[2] << 8) | octets[3]) >>> 0;
};
exports.ipv4ToNumber = ipv4ToNumber;
const numberToIpv4 = (value) => {
    const octets = [24, 16, 8, 0].map((shift) => (value >> shift) & 255);
    return octets.join('.');
};
exports.numberToIpv4 = numberToIpv4;
//# sourceMappingURL=ipv4ToNumber.js.map